import {FC, ReactNode} from "react";
import {color_red_default, color_transparent, color_white} from "../../../constants/colors";
import {Button} from "./Button";

type ButtonBigDefaultProps = {
    children: ReactNode,
    width: number,
    height: number,
    disabled: boolean,
    borderColor: string,
    color: string,
    fontSize: number,
    style: React.CSSProperties,
    onClick: () => void,
}
export const ButtonOutlined: FC<ButtonBigDefaultProps> = ({
    children,
    width,
    height,
    disabled,
    borderColor= color_red_default,
    color = color_red_default,
    fontSize = 16,
    style,
    onClick = () => {},
}) => {
    return (
        <Button
            onClick={onClick}
            outline={false}
            width={width}
            height={height}
            disabled={disabled}
            backgroundColor={color_transparent}
            color={color}
            borderColor={borderColor}
            fontSize={fontSize}
            style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-evenly',
                ...style,
            }}
        >
            {children}
        </Button>
    )
}